<template>
  <div class="oai-InviteStep">
    <OnboardingAiStepHeader
      :subtitle="$t('onboarding.ai.invite.subtitle')"
      :wizard-step="wizardStep"
      title-key-path="onboarding.ai.invite.title_prefix"
      title-key-name="okrChampions"
      :title-key-accent="$t('onboarding.ai.invite.title_accent')"
    >
      <template #after-subtitle>
        <div class="oai-InviteStep_Insight">
          <p class="oai-InviteStep_InsightTitle">
            {{ $t('onboarding.ai.invite.insight_title') }}
          </p>
          <p class="oai-InviteStep_InsightSource">
            {{ $t('onboarding.ai.invite.insight_source') }}
          </p>
        </div>
      </template>
    </OnboardingAiStepHeader>

    <OnboardingAiInviteUsersEmailInvitation
      v-if="isEmailInvitationMode"
      @next="emit('next', $event)"
    />
    <OnboardingAiInviteUsersAdminInvitation v-else @next="emit('next', $event)" />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import { useOnboardingAiTracking } from '@/composables/onboarding-ai-step'
import { EVENT_NAMES } from '@/tracking/amplitude-helpers'

import OnboardingAiInviteUsersAdminInvitation from '@/components/ui/onboarding-ai/OnboardingAiInviteUsersAdminInvitation'
import OnboardingAiInviteUsersEmailInvitation from '@/components/ui/onboarding-ai/OnboardingAiInviteUsersEmailInvitation'
import OnboardingAiStepHeader from '@/components/ui/onboarding-ai/OnboardingAiStepHeader'

defineOptions({
  name: 'OnboardingAiInviteStep'
})

defineProps({
  wizardStep: {
    type: Number,
    required: true
  }
})

const { logEvent } = useOnboardingAiTracking()

const emit = defineEmits({
  next: null,
  finish: null
})

const store = useStore()

const isWebApp = computed(() => store.state.appContext.isWebApp)
const isCrossPlatformApp = computed(() => store.state.appContext.isCrossPlatformApp)
const isEmailInvitationMode = computed(() => isWebApp.value || isCrossPlatformApp.value)

onMounted(() => {
  logEvent(EVENT_NAMES.ONBOARDING_INVITE_LEADERSHIP_VIEWED)
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';
@import '~@/assets/styles/app-table-helpers';

.oai-InviteStep {
  @extend %oai-wizard-step-shell;
}

.oai-InviteStep_Insight {
  display: grid;
  gap: 10px;
  padding: 12px 12px 12px 18px;
  border-left: 2px solid $primary-color-next;
  border-radius: $border-radius-md;
  background: $oai-bg;
}

.oai-InviteStep_InsightTitle {
  margin: 0;
  font-size: $fs-14;
  line-height: 20px;
  font-weight: fw('semi-bold');
  color: $oai-text-action;
}

.oai-InviteStep_InsightSource {
  margin: 0;
  font-size: $fs-12;
  line-height: 18px;
  color: $oai-text-action;
}
</style>
